import { GQLParamBuilder } from "../../../../helpers";
import { useState } from "react";
import { useEffect } from "react";
import { getImportSchemas } from "js/graphql/resolvers/importWizard.resolver";

const getQueryPromise = (client, op, vars) => {
  const opBuilder = new GQLParamBuilder(client);

  opBuilder.setOperation(op);

  const variables = { ...vars };

  opBuilder.setVariables({ ...variables });

  return opBuilder.exec();
};

const fetchLastSchema = async (client, variables) => {
  try {
    const opBuilder = new GQLParamBuilder(client);

    opBuilder.setOperation(getImportSchemas);

    opBuilder.setVariables({ ...variables });

    const schemaFound = await opBuilder.exec();

    return schemaFound;
  } catch (error) {}
};
export const useGetSchema = ({ client, variables }) => {
  const [schema, setSchema] = useState();
  const [allowDuplicatedEmails, setAllowDuplicatedEmails] = useState(false);
  const [otherOptions, setOtherOptions] = useState();
  //const [otherOptions, setOtherOptions] = useState()

  useEffect(
    () => {
      const getSchema = async () => {
        const schemaFound = await fetchLastSchema(client, variables);
        // Control de existencia y estructura segura
        const getImportSchemas =
          schemaFound &&
          schemaFound.data &&
          Array.isArray(schemaFound.data.getImportSchemas)
            ? schemaFound.data.getImportSchemas
            : null;

        setAllowDuplicatedEmails(
          getImportSchemas && getImportSchemas.length > 0
            ? getImportSchemas[0].allowDuplicatedEmails
            : false
        );

        setOtherOptions(
          getImportSchemas && getImportSchemas.length > 0
            ? getImportSchemas[0].otherOptions
            : null
        );

        setSchema(
          getImportSchemas && getImportSchemas.length > 0
            ? getImportSchemas[0].json
            : null
        );
      };

      getSchema();
    },
    [variables]
  );

  return { schema, allowDuplicatedEmails, otherOptions };
};
